import { render, staticRenderFns } from "./addPersonalObligee.vue?vue&type=template&id=6fa92b00&scoped=true&"
import script from "./addPersonalObligee.vue?vue&type=script&lang=js&"
export * from "./addPersonalObligee.vue?vue&type=script&lang=js&"
import style0 from "./addPersonalObligee.vue?vue&type=style&index=0&id=6fa92b00&prod&lang=less&"
import style1 from "./addPersonalObligee.vue?vue&type=style&index=1&id=6fa92b00&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa92b00",
  null
  
)

export default component.exports